import { Button, TextField } from "@material-ui/core";
import { DFDialog } from "components/DFCustoms";
import React, { useEffect, useState } from "react";
import { useUpdateNote } from "utils/hooks/apiHooks/notes-feature/useUpdateNote";

export default function UpsertNoteDialog({
  editingId,
  open,
  handleAddNote,
  initialValue,
  close,
}: Props) {
  const [textValue, setTextValue] = useState(initialValue);
  const [updateNote, loadingUpdateNote] = useUpdateNote(close);

  useEffect(() => {
    setTextValue(initialValue);
  }, [initialValue]);
  return (
    <DFDialog
      open={open}
      title={`${editingId ? "Edit" : "Add"} Note`}
      content={
        <div style={{ minWidth: "400px" }}>
          <div>
            <TextField
              variant="outlined"
              fullWidth
              size="small"
              multiline
              onChange={(e) => {
                setTextValue(e.target.value);
              }}
              value={textValue}
            />
            <br /> <br />
            <Button
              variant="contained"
              color="primary"
              disabled={loadingUpdateNote}
              onClick={() => {
                setTextValue(null);

                if (editingId)
                  updateNote({
                    id: editingId,
                    note: {
                      description: textValue,
                    },
                  });
                else handleAddNote(textValue);
              }}
            >
              Save Note
            </Button>
            <Button
              onClick={() => {
                close();
                setTextValue(initialValue);
              }}
              disabled={loadingUpdateNote}
            >
              Cancel
            </Button>
            <br />
            <br />
          </div>
        </div>
      }
      onClose={() => {
        !loadingUpdateNote && close();
      }}
      actions={<></>}
    />
  );
}

type Props = {
  editingId?: string;
  open: boolean;
  handleAddNote?: any;
  initialValue: string;
  close: () => void;
};
